module.exports = __webpack_public_path__ + "static/media/grey-logo.d31100ca.png";